import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
// App
import App from 'app/App';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDayjs';
import { setupStore } from 'store';

const store = setupStore();
export const storeDispatch = store.dispatch;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // ToDO: For some reason Redux dispatch action twice
  // <React.StrictMode>
    <LocalizationProvider dateAdapter={DateAdapter}>
      <Provider store={store}>
        <BrowserRouter>
          <SnackbarProvider maxSnack={5}>
            <App />
          </SnackbarProvider>
        </BrowserRouter>
      </Provider>
    </LocalizationProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
